import pick from 'lodash/fp/pick';
import { connect } from 'react-redux';

import { videoFolderActions } from '../store/modules/videoFolder';
import { ApplicationState } from '../store/types';

import { videoFolderSelectors } from './../store/modules/videoFolder';

export type WithVideoFolder = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

const mapStateToProps = (state: ApplicationState) => ({
  videoFolder: state.videoFolder,
  folderTree: videoFolderSelectors.selectFolderTree(state),
  isFolderEmpty: videoFolderSelectors.isFolderEmpty(state),
  makeFolderPath: videoFolderSelectors.makeFolderPath(state),
  findFolderInTree: videoFolderSelectors.findFolderInTree(state),
  makeFolderTreeListByPath: videoFolderSelectors.makeFolderTreeListByPath(state)
});

const mapDispatchToProps = pick<
  typeof videoFolderActions,
  | 'moveFolder'
  | 'renameFolder'
  | 'deleteFolder'
  | 'createFolder'
  | 'fetchRootFolder'
  | 'fetchFolderTree'
  | 'expandFolderInTree'
  | 'fetchFolderByPath'
  | 'moveProject'
  | 'updateProjectMeta'
  | 'deleteProject'
  | 'duplicateProject'
  | 'clearNewFolder'
>([
  'moveFolder',
  'renameFolder',
  'deleteFolder',
  'createFolder',
  'fetchRootFolder',
  'fetchFolderTree',
  'expandFolderInTree',
  'fetchFolderByPath',
  'moveProject',
  'updateProjectMeta',
  'deleteProject',
  'duplicateProject',
  'clearNewFolder'
])(videoFolderActions);

export default connect(mapStateToProps, mapDispatchToProps);
